function footerDropdown() {
  /*
    / Footer Dropdown Toggle
    */
  const dropdownMenuMobile = $('.footer-menu li.menu-item-has-children > a')

  // Add dropdown trigger element
  dropdownMenuMobile.append('<span class="toggle"></span>')

  const dropdownToggleMobile = $('.footer-menu .toggle')
  const showClass = 'show'

  // a single MediaQuery
  const isMobile = window.matchMedia('only screen and (max-width: 767px)')

  // Setup trigger click
  dropdownToggleMobile.click(handleMobileClick)

  function handleMobileClick(event) {
    if (!isMobile.matches) return
    console.log('clicked')
    event.preventDefault()
    const $this = $(this)

    console.log('yes!')

    // Toggle show class
    $this.parents('.menu-item').toggleClass(showClass)
  }
}

$(document).ready(function () {
  footerDropdown()
})
